import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full py-8 px-5 sm:px-8" style={{
      backgroundColor: '#0a0a0f',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }} data-id="element-18">
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-19">
          <p className="text-sm" style={{
          color: '#a1a1aa'
        }} data-id="element-20">
            © {new Date().getFullYear()} Meeting Mercenary Protocol. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-21">
            <button onClick={() => setActiveModal('privacy')} className="text-sm transition-colors duration-200" style={{
            color: '#a1a1aa'
          }} onMouseEnter={e => e.currentTarget.style.color = '#f97316'} onMouseLeave={e => e.currentTarget.style.color = '#a1a1aa'} data-id="element-22">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm transition-colors duration-200" style={{
            color: '#a1a1aa'
          }} onMouseEnter={e => e.currentTarget.style.color = '#f97316'} onMouseLeave={e => e.currentTarget.style.color = '#a1a1aa'} data-id="element-23">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      {/* Legal Modals */}
      <AnimatePresence data-id="element-24">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto py-10 px-4" style={{
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(4px)'
      }} onClick={() => setActiveModal(null)} data-id="element-25">
            <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="relative w-full max-w-2xl rounded-xl p-8 sm:p-10 my-4" style={{
          backgroundColor: '#111118',
          border: '1px solid rgba(255,255,255,0.1)'
        }} onClick={e => e.stopPropagation()} data-id="element-26">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 p-2 rounded-lg transition-colors duration-200" style={{
            color: '#a1a1aa'
          }} onMouseEnter={e => e.currentTarget.style.color = '#ffffff'} onMouseLeave={e => e.currentTarget.style.color = '#a1a1aa'} aria-label="Close" data-id="element-27">
                <XIcon className="w-5 h-5" data-id="element-28" />
              </button>

              {activeModal === 'privacy' && <PrivacyContent data-id="element-29" />}
              {activeModal === 'terms' && <TermsContent data-id="element-30" />}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <div className="space-y-6" data-id="element-31">
      <h2 className="text-2xl font-black tracking-tight text-white" data-id="element-32">
        Privacy Policy
      </h2>
      <p className="text-sm" style={{
      color: '#a1a1aa'
    }} data-id="element-33">
        Last updated: February 2026
      </p>

      <div className="space-y-5 text-sm leading-relaxed" style={{
      color: '#d4d4d8'
    }} data-id="element-34">
        <section data-id="element-35">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-36">Overview</h3>
          <p data-id="element-37">
            Meeting Mercenary Protocol ("we," "us," or "our") respects your
            privacy. This Privacy Policy explains how we collect, use, and
            protect your information when you purchase and use our digital
            product.
          </p>
        </section>

        <section data-id="element-38">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-39">
            Information We Collect
          </h3>
          <p data-id="element-40">
            When you purchase The Meeting Mercenary Protocol, we collect only
            the information necessary to process your transaction:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1" style={{
          color: '#a1a1aa'
        }} data-id="element-41">
            <li data-id="element-42">
              Email address (for product delivery and purchase confirmation)
            </li>
            <li data-id="element-43">
              Payment information (processed securely by our third-party payment
              processor — we do not store your card details)
            </li>
          </ul>
        </section>

        <section data-id="element-44">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-45">
            How We Use Your Information
          </h3>
          <p data-id="element-46">Your information is used solely to:</p>
          <ul className="list-disc list-inside mt-2 space-y-1" style={{
          color: '#a1a1aa'
        }} data-id="element-47">
            <li data-id="element-48">Deliver the digital product to you</li>
            <li data-id="element-49">Process refund requests within the 7-day guarantee period</li>
            <li data-id="element-50">Send purchase-related communications</li>
          </ul>
          <p className="mt-2" data-id="element-51">
            We do not sell, rent, or share your personal information with third
            parties for marketing purposes.
          </p>
        </section>

        <section data-id="element-52">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-53">
            Cookies &amp; Analytics
          </h3>
          <p data-id="element-54">
            This website may use basic analytics to understand page traffic. No
            personally identifiable information is tracked beyond what is
            necessary for the purchase process.
          </p>
        </section>

        <section data-id="element-55">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-56">Data Security</h3>
          <p data-id="element-57">
            We implement industry-standard security measures to protect your
            information. Payment processing is handled by PCI-compliant
            third-party providers.
          </p>
        </section>

        <section data-id="element-58">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-59">Your Rights</h3>
          <p data-id="element-60">
            You may request deletion of your personal data at any time. Upon
            request, we will remove all stored information associated with your
            purchase, subject to legal retention requirements.
          </p>
        </section>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6" data-id="element-61">
      <h2 className="text-2xl font-black tracking-tight text-white" data-id="element-62">
        Terms of Service
      </h2>
      <p className="text-sm" style={{
      color: '#a1a1aa'
    }} data-id="element-63">
        Last updated: February 2026
      </p>

      <div className="space-y-5 text-sm leading-relaxed" style={{
      color: '#d4d4d8'
    }} data-id="element-64">
        <section data-id="element-65">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-66">Agreement</h3>
          <p data-id="element-67">
            By purchasing The Meeting Mercenary Protocol, you agree to these
            Terms of Service. Please read them carefully before completing your
            purchase.
          </p>
        </section>

        <section data-id="element-68">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-69">
            Product Description
          </h3>
          <p data-id="element-70">
            The Meeting Mercenary Protocol is a digital product containing 25
            meeting exit scripts, pre-meeting filter templates, and
            communication frameworks. It is delivered electronically upon
            purchase.
          </p>
        </section>

        <section data-id="element-71">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-72">
            License &amp; Usage
          </h3>
          <p data-id="element-73">
            Upon purchase, you receive a personal, non-transferable license to
            use the scripts and templates for your own professional use. You may
            not:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1" style={{
          color: '#a1a1aa'
        }} data-id="element-74">
            <li data-id="element-75">Redistribute, resell, or share the product with others</li>
            <li data-id="element-76">Reproduce the content for commercial purposes</li>
            <li data-id="element-77">Claim authorship of the scripts or templates</li>
          </ul>
        </section>

        <section data-id="element-78">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-79">
            Pricing &amp; Payment
          </h3>
          <p data-id="element-80">
            The Meeting Mercenary Protocol is priced at $6.39 USD. All prices
            are subject to change without notice. Payment is processed securely
            through our third-party payment provider.
          </p>
        </section>

        <section data-id="element-81">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-82">Refund Policy</h3>
          <p data-id="element-83">
            We offer a 7-day money-back guarantee. If you have not saved at
            least 5 hours of meeting time within 7 days of purchase, you are
            entitled to a full refund of $6.39. Refund requests must be made
            within 7 days of the original purchase date. No questions asked.
          </p>
        </section>

        <section data-id="element-84">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-85">Disclaimer</h3>
          <p data-id="element-86">
            The Meeting Mercenary Protocol provides communication scripts and
            templates for professional use. Results may vary based on individual
            workplace culture and circumstances. We make no guarantees regarding
            specific outcomes in your workplace beyond our stated refund policy.
          </p>
        </section>

        <section data-id="element-87">
          <h3 className="text-base font-bold text-white mb-2" data-id="element-88">
            Intellectual Property
          </h3>
          <p data-id="element-89">
            All content within The Meeting Mercenary Protocol is protected by
            copyright. The scripts, templates, and frameworks are original works
            and remain the intellectual property of Meeting Mercenary Protocol.
          </p>
        </section>
      </div>
    </div>;
}